import enCountries from 'i18n-iso-countries/langs/en.json';
import esCountries from 'i18n-iso-countries/langs/es.json';
import frCountries from 'i18n-iso-countries/langs/fr.json';
import caCountries from 'i18n-iso-countries/langs/ca.json';
import countries from 'i18n-iso-countries';
countries.registerLocale(enCountries);
countries.registerLocale(esCountries);
countries.registerLocale(frCountries);
countries.registerLocale(caCountries);
export const countriesI18n = countries;